import { ToastContainer } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.min.css';
import styled, { css } from 'styled-components';

import { spacing } from '@savgroup-front-common/primitive/helpers/spacing';
import { rem } from '@savgroup-front-common/primitive/helpers/units';

import { fontStyle } from '../../../../theme/helpers/fontStyle';
import { noticeOptions, toastOptions } from '../../Toast.config';
import { $ToastTitle } from '../ToastBody/ToastBody.styles';

interface ToastContainerProps {
  $topOffset: string;
}
interface TestProps {
  $height: number;
}

export const $ToastContainer = styled.div<TestProps>`
  height: ${({ $height }) => {
    return rem($height);
  }};
  margin-bottom: '${spacing('lg')}';
`;

const toastStyle = css`
  position: relative;
  border-radius: ${({ theme }) => theme.tw.radius.sm};
  ${fontStyle('sm')};

  .Toastify__close-button {
    color: ${({ theme }) => theme.systemColors.defaultTextColor};
  }
  &::before {
    content: '';
    position: absolute;
    top: ${spacing('sm')};
    bottom: ${spacing('sm')};
    left: ${spacing('sm')};
    width: ${spacing(1.5)};
    border-radius: ${({ theme }) => theme.newUI.borders.bigRadius};
    pointer-events: none;
  }

  .Toastify__toast-body {
    color: ${({ theme }) => theme.systemColors.defaultTextColor};

    margin: 0;
    display: flex;
    align-items: center;
    padding: 0 0 0 ${spacing('md')};
    img {
      max-width: 100%;
      height: auto;
    }
  }
  .Toastify__toast-icon {
    min-width: ${spacing('xl')};
    max-height: ${spacing('xl')};
    height: auto;
    width: auto;
    svg {
      max-height: ${spacing('xl')};
      min-width: ${spacing('xl')};
      height: auto;
    }
  }
`;
const noticeStyle = css`
  color: ${({ theme }) => theme.colors.white};
  padding: 0;
  min-height: ${spacing(9)};
  border-radius: ${({ theme }) => theme.tw.radius['3xl']};

  ${$ToastTitle} {
    display: none;
  }
  .Toastify__toast-icon {
    display: none;
  }

  .Toastify__close-button {
    display: none;
  }
  .Toastify__toast-body {
    padding: ${spacing('sm')} ${spacing('lg')};
  }
`;
const $BridgeToastContainer = styled(ToastContainer)<ToastContainerProps>`
  &&&.Toastify__toast-container--top-right {
    top: ${({ $topOffset }) => $topOffset};
    padding: 0;
  }

  &&&.Toastify__toast-container--bottom-center {
    margin: 0 auto;
    width: auto;
    transform: translateX(-50%);
  }

  .${toastOptions.className} {
    ${toastStyle}
  }
  .${noticeOptions.className} {
    ${noticeStyle}
  }

  .Toastify__toast--info.${toastOptions.className} {
    background-color: ${({ theme }) => theme.colors.neutralBackground};
    .Toastify__toast-icon svg {
      color: ${({ theme }) => theme.newUI.iconColors.primary.color};
    }
  }
  .Toastify__toast--info.${toastOptions.className}::before {
    background-color: ${({ theme }) => theme.newUI.iconColors.primary.color};
  }
  .Toastify__toast--warning.${toastOptions.className} {
    background-color: ${({ theme }) => theme.colors.neutralBackground};
    .Toastify__toast-icon svg {
      color: ${({ theme }) => theme.colors.alert};
    }
  }
  .Toastify__toast--warning.${toastOptions.className}::before {
    background-color: ${({ theme }) => theme.colors.alert};
  }
  .Toastify__toast--success.${toastOptions.className} {
    background-color: ${({ theme }) => theme.colors.neutralBackground};
    .Toastify__toast-icon svg {
      color: ${({ theme }) => theme.newUI.iconColors.success.color};
    }
  }
  .Toastify__toast--success.${toastOptions.className}::before {
    background-color: ${({ theme }) => theme.newUI.iconColors.success.color};
  }
  .Toastify__toast--error.${toastOptions.className} {
    background-color: ${({ theme }) => theme.colors.neutralBackground};
    .Toastify__toast-icon svg {
      color: ${({ theme }) => theme.newUI.iconColors.alert.color};
    }
  }
  .Toastify__toast--error.${toastOptions.className}::before {
    background-color: ${({ theme }) => theme.newUI.iconColors.alert.color};
  }

  .Toastify__toast--info.${noticeOptions.className} {
    background-color: ${({ theme }) => theme.colors.primary};
  }
  .Toastify__toast--warning.${noticeOptions.className} {
    background-color: ${({ theme }) => theme.colors.alert};
  }
  .Toastify__toast--success.${noticeOptions.className} {
    background-color: ${({ theme }) => theme.colors.success};
  }
  .Toastify__toast--error.${noticeOptions.className} {
    background-color: ${({ theme }) => theme.colors.danger};
  }
`;

export default $BridgeToastContainer;
